"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "barcis": {
    "41030a85": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "skipSearch": false
    }],
    "arcola": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b9a6ecac": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "skipSearch": false
    }],
    "armasio": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4c2c9803": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "skipSearch": false
    }],
    "cimacosta": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ddcafd18": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "skipSearch": false
    }],
    "fontane": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "21139902": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "skipSearch": false
    }],
    "losie": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ae4590fe": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "skipSearch": false
    }],
    "pentina": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f9fbd97": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "skipSearch": false
    }],
    "pezzeda": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d88ba399": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "skipSearch": false
    }],
    "portuz": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "60dde151": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "skipSearch": false
    }],
    "predaia": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7c485839": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "skipSearch": false
    }],
    "vallata": [{
      "hkey": "1ecb6b2b",
      "slug": "barcis",
      "name": "Barcis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;